import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'

import styled from 'styled-components';
import { DataContext } from '../../contexts/DataContext';
import { DEFAULT_TITLE, STATIC_URL } from '../../lib/settings';
import { AuthContext } from '../../contexts/AuthContext';
import AppPage from '../../layouts/AppPage';
import PieceContent from './PieceContent';
import { Link, useParams } from 'react-router-dom';
import PAGES from '../../lib/pages';
import { PageNotFoundSection } from '../PageNotFound';
import { metaTags } from '../../lib/utils/metaTags';

export default function Piece({isDraft=false}) {
  const { piece, setPiece } = useContext(DataContext);
  const { api } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();

  const getPiece = useCallback(async (pieceId) => {
    setIsLoading(true);
    try {
      const response = isDraft ? await api.getDraft(pieceId) : await api.getPiece(pieceId);
      setPiece({...response.data});
    } catch (error) {
    };
    setIsLoading(false);
  }, [api, setPiece, isDraft]);

  useEffect(() => {
    if (id) {
      getPiece(id);
    }

    return () => {
      setPiece(null);
    }
  }, [getPiece, setPiece, id]);

  const MetaTags = useMemo(() => {
    return metaTags({
      title: `${DEFAULT_TITLE} ${piece ? `| ${piece.title}` : ''}`,
      description: piece?.authors?.map(author => author.full_name).join(', ') + ' | ' + piece?.title || '',
      image: piece?.image_path,
      url: `https://chimeras.world/pieces/${id}`
    })
  }, [piece, id]);

  return (
    <AppPage>
      {MetaTags}
      <PIECE>
        {!isLoading && piece && <>
          <div className="top">
            <img src={`${STATIC_URL}/${piece.image_path}`} alt={piece.title} />
            <h3>{piece.title}</h3>
            <p>
              {piece.authors?.map((author, index) => (
                <Link key={index} to={`${PAGES.authors}/${author.slug}`}>{author.full_name}</Link>
              ))}
            </p>
          </div>
          {piece.content &&
            <div className="content">
              <PieceContent content={piece.content} />
            </div>
          }
        </>}
      </PIECE>
      {!isLoading && !piece && <PageNotFoundSection />}
    </AppPage>
  )
}

const PIECE = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;

  & .top {
    display: flex;
    flex-direction: column;
    align-items: center;

    font-family: var(--primary-font);
  }  

  & .top img {
    margin-bottom: 20px;
    width: 100%;
  }

  & .top h3 {
    margin-bottom: 0.32rem;
    font-size: 1rem;
    font-weight: 700;
    text-align: center;
  }

  & .top p {
    font-size: 0.875rem;
    font-weight: 400;
    text-align: center;
  }

  & .top p > a {
    text-decoration: none;
    color: black;
  }

  & .top p a:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  & .top p a:not(:last-child)::after {
    content: ',';
    margin-right: 0.5rem;
  }

  @media (min-width: 768px) {
    // padding: 50px 50px 0 50px;

    & .top {
      padding: 50px 50px 0 50px;
    }

    & .top img {
      margin-bottom: 2.5rem;
      width: 450px;
      width: 36vw;
    }

    & .top h3 {
      margin-bottom: 0.625rem;
      font-size: 1.5rem;
    }

    & .top p {
      font-size: 1.25rem;
      font-weight: 400;
      text-align: left;
    }

    & .content {
      min-height: 20rem;
    }
  }
`;
